<template>
  <v-container class="adhoc-week-schedule-list" fluid>
    <v-row>
      <v-col>
        <v-container fluid v-if="editingAdhocWeekSchedule">
          <v-row>
            <v-col>
              <v-text-field outlined
                            :label="$t('admin_acc_adhoc_week_schedule.name')"
                            :placeholder="$t('admin_acc_adhoc_week_schedule.name')"
                            v-model="editingAdhocWeekSchedule.name"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field outlined
                            type="number"
                            min="0"
                            :label="$t('admin_acc_adhoc_week_schedule.priority')"
                            :placeholder="$t('admin_acc_adhoc_week_schedule.priority')"
                            v-model="editingAdhocWeekSchedule.priority"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <DateInput v-model="editingAdhocWeekSchedule.valid_from"
                         :label="$t('admin_acc_adhoc_week_schedule.valid_from')"
                         :placeholder="$t('admin_acc_adhoc_week_schedule.valid_from')"></DateInput>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <DateInput v-model="editingAdhocWeekSchedule.valid_until"
                         :label="$t('admin_acc_adhoc_week_schedule.valid_until')"
                         :placeholder="$t('admin_acc_adhoc_week_schedule.valid_until')"></DateInput>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row v-for="i in Array(7).keys()" :key="i">
            <v-col>
              <v-select outlined
                        :label="$t(`admin_acc_week_schedule.day_${i+1}`)"
                        :placeholder="$t(`admin_acc_week_schedule.day_${i+1}`)"
                        :items="dayScheduleOptions"
                        v-model="editingAdhocWeekSchedule[`day_${i+1}`]"
                        clearable></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select outlined
                        :label="$t('admin_acc_week_schedule.public_holiday_schedule')"
                        :placeholder="$t('admin_acc_week_schedule.public_holiday_schedule')"
                        :items="dayScheduleOptions"
                        v-model="editingAdhocWeekSchedule.public_holiday_schedule"
                        clearable></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-right">
              <v-spacer></v-spacer>
              <v-btn text color="#2bc7ca"
                     @click="saveAdhocWeekSchedule">
                {{ $t('save') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>

        <div class="adhoc-week-schedule-select-schedule-overlay" v-if="!editingAdhocWeekSchedule">
          <div class="text-center">{{ $t('admin_acc_day_schedule.select_schedule') }}</div>
        </div>
      </v-col>
      <v-col>
        <v-row>
          <v-col>
            {{ $t('admin_acc_facility_type.adhoc_week_schedule') }}
          </v-col>
          <v-col class="text-right">
            <v-menu v-model="addAdhocWeekScheduleMenuOpened"
                    :close-on-content-click="false"
                    left
                    offset-x>
              <template v-slot:activator="{on, attrs}">
                <v-btn small
                       v-bind="attrs"
                       v-on="on">
                  <v-icon>fas fa-plus</v-icon>
                </v-btn>
              </template>

              <v-card outlined>
                <v-card-title>{{ $t('admin_acc_adhoc_week_schedule.add_title') }}</v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-text-field outlined
                                    :label="$t('admin_acc_day_schedule.name')"
                                    :placeholder="$t('admin_acc_day_schedule.name')"
                                    v-model="addingAdhocWeekScheduleName">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field outlined
                                    type="number"
                                    min="0"
                                    :label="$t('admin_acc_adhoc_week_schedule.priority')"
                                    :placeholder="$t('admin_acc_adhoc_week_schedule.priority')"
                                    v-model="addingAdhocWeekSchedulePriority"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <DateInput v-model="addingAdhocWeekScheduleValidFrom"
                                 :label="$t('admin_acc_adhoc_week_schedule.valid_from')"
                                 :placeholder="$t('admin_acc_adhoc_week_schedule.valid_from')"></DateInput>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <DateInput v-model="addingAdhocWeekScheduleValidUntil"
                                 :label="$t('admin_acc_adhoc_week_schedule.valid_until')"
                                 :placeholder="$t('admin_acc_adhoc_week_schedule.valid_until')"></DateInput>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text color="#2bc7ca"
                         @click="addAdhocWeekScheduleMenuOpened = false">
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn text color="#2bc7ca"
                         @click="addAdhocWeekSchedule"
                         :disabled="!addingAdhocWeekScheduleName || !addingAdhocWeekScheduleValidFrom || !addingAdhocWeekScheduleValidUntil">
                    {{ $t('save') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-col>
        </v-row>
        <v-data-table :items="adhocWeekSchedules"
                      :headers="adhocWeekScheduleHeaders"
                      item-class="adhoc-week-schedule-list-table-body"
                      hide-default-footer>
          <template v-slot:item.actions="data">
            <font-awesome-icon icon="edit"
                               class="mr-3"
                               @click.stop="editAdhocWeekSchedule(data.item)"></font-awesome-icon>
            <font-awesome-icon icon="trash"
                               @click.stop="deleteAdhocWeekSchedule(data.item)"></font-awesome-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {computed, onMounted, ref} from "@vue/composition-api";
import DateInput from "../../DateInput";

export default {
  name: 'AdhocWeekScheduleList',
  components: {DateInput},
  props: {
    typeId: String,
  },
  setup(props, {root}) {
    // Adhoc Week Schedule
    const adhocWeekSchedules = ref([]);
    const getAdhocWeekSchedule = function () {
      root.$callAPI('room/admin/item_type/adhoc_schedule/', {
        type_id: props.typeId,
      }, function (response) {
        let schedules = response.body.adhoc_schedules;

        schedules.sort((a, b) => {
          return b.priority - a.priority;
        })

        adhocWeekSchedules.value = schedules;
      });
    };
    const adhocWeekScheduleHeaders = [
      {text: root.$t('admin_acc_adhoc_week_schedule.name'), value: 'name'},
      {text: root.$t('admin_acc_adhoc_week_schedule.priority'), value: 'priority'},
      {text: '', value: 'actions', align: 'end'},
    ];
    const addAdhocWeekScheduleMenuOpened = ref(false);
    const addingAdhocWeekScheduleName = ref('');
    const addingAdhocWeekSchedulePriority = ref(0);
    const addingAdhocWeekScheduleValidFrom = ref(null);
    const addingAdhocWeekScheduleValidUntil = ref(null);
    const addAdhocWeekSchedule = function () {
      root.$callAPI('room/admin/item_type/adhoc_schedule/set/', {
        type_id: props.typeId,
        name: addingAdhocWeekScheduleName.value,
        priority: addingAdhocWeekSchedulePriority.value,
        valid_from: addingAdhocWeekScheduleValidFrom.value,
        valid_until: addingAdhocWeekScheduleValidUntil.value,
      }, function (response) {
        addAdhocWeekScheduleMenuOpened.value = false;
        addingAdhocWeekScheduleName.value = '';
        addingAdhocWeekSchedulePriority.value = 0;
        addingAdhocWeekScheduleValidFrom.value = null;
        addingAdhocWeekScheduleValidUntil.value = null;
        getAdhocWeekSchedule();
      });
    };
    const editingAdhocWeekSchedule = ref(null);
    const editAdhocWeekSchedule = function (schedule) {
      editingAdhocWeekSchedule.value = schedule;
    }
    const deleteAdhocWeekSchedule = function (schedule) {
      if (confirm(root.$t('admin_acc_day_schedule.confirm_delete'))) {
        root.$callAPI('room/admin/item_type/adhoc_schedule/delete/', {
          schedule_id: schedule.id,
        }, function (response) {
          getAdhocWeekSchedule();
        });
      }
    };
    const saveAdhocWeekSchedule = function () {
      root.$callAPI('room/admin/item_type/adhoc_schedule/set/', {
        ...editingAdhocWeekSchedule.value,
        schedule_id: editingAdhocWeekSchedule.value.id,
        type_id: props.typeId,
      }, function (response) {
        getAdhocWeekSchedule();
      });
    };

    // Day Schedule
    const daySchedules = ref([]);
    const dayScheduleOptions = computed(() => {
      return daySchedules.value.map((s) => {
        return {text: s.name, value: s};
      })
    });
    const dayScheduleMap = computed(() => {
      let map = {};

      daySchedules.value.forEach((s) => {
        map[s.id] = s;
      });

      return map;
    });
    const getDaySchedules = function () {
      root.$callAPI('room/admin/item_type/day_schedule/', {
        type_id: props.typeId,
      }, function (response) {
        daySchedules.value = response.body.day_schedules;
      });
    };

    onMounted(() => {
      getAdhocWeekSchedule();
      getDaySchedules();
    })

    return {
      adhocWeekSchedules,
      adhocWeekScheduleHeaders,
      addAdhocWeekScheduleMenuOpened,
      addingAdhocWeekScheduleName,
      addingAdhocWeekSchedulePriority,
      addingAdhocWeekScheduleValidFrom,
      addingAdhocWeekScheduleValidUntil,
      addAdhocWeekSchedule,
      editingAdhocWeekSchedule,
      editAdhocWeekSchedule,
      deleteAdhocWeekSchedule,
      saveAdhocWeekSchedule,
      dayScheduleOptions,
      dayScheduleMap,
    };
  },
}
</script>

<style lang="less">
.adhoc-week-schedule-list {
  .adhoc-week-schedule-select-schedule-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);

    div {
      font-size: 120%;
      font-weight: bold;
      color: white;
      padding-top: 60px;
    }
  }
}
</style>
